import { render, staticRenderFns } from "./RecommendDialog.vue?vue&type=template&id=52ccb1e6&scoped=true&"
import script from "./RecommendDialog.vue?vue&type=script&lang=js&"
export * from "./RecommendDialog.vue?vue&type=script&lang=js&"
import style0 from "./RecommendDialog.vue?vue&type=style&index=0&id=52ccb1e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ccb1e6",
  null
  
)

export default component.exports